import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text, mergeStyles } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import classNames from 'classnames';
import { withCustomRendering } from '../custom-component';

const labelStyles = mergeStyles({
  fontWeight: 400,
  fontSize: 14,
  lineHeight: 19,
  width: 148,
  paddingLeft: 8,
  paddingTop: 10,
  paddingBottom: 10,
});

const PropertyLabel = ({ label }) => {
  const i18n = useContext(I18nContext);
  return (
    <div className={classNames('property-label', labelStyles)}><Text>{i18n.getString(label)}</Text></div>
  );
};

PropertyLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

const PropertyLabelWrapped = withCustomRendering(PropertyLabel);

export { PropertyLabelWrapped as PropertyLabel };
